<template>
  <keep-alive include="CoveShedList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "CoveShed",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
